import { CHECK_STATUS } from '../types';
import abortAfter from './abortAfter';

export const id = 'manifestCdnAccess';
export const label = 'Manifest / CDN Access';

const MANIFEST_BASE =
  'https://content.uplynk.com/event/a88054d7107846749e32deddfd6a7180.m3u8?expand=ad%2Cgam_params%2Cdrm_wv_l3&rays=cabeg';
const TIMEOUT_MS = 10000;

export async function run(ctx) {
  const start = Date.now();
  const url = `${MANIFEST_BASE}&upbust=${Date.now()}`;

  let httpStatus = null;
  let hasExtm3u = false;

  try {
    const res = await fetch(url, {
      signal: abortAfter(TIMEOUT_MS),
    });
    httpStatus = res.status;

    if (res.status === 200) {
      const body = await res.text();
      hasExtm3u = body.includes('#EXTM3U');
    }
  } catch (err) {
    const durationMs = Date.now() - start;
    return {
      id,
      label,
      status: CHECK_STATUS.FAIL,
      detail: `Manifest fetch failed: ${err.message}`,
      detailData: { httpStatus: null, hasExtM3U: false },
      durationMs,
    };
  }

  const durationMs = Date.now() - start;

  if (httpStatus === 200 && hasExtm3u) {
    return {
      id,
      label,
      status: CHECK_STATUS.PASS,
      detail: 'Manifest accessible',
      detailData: { httpStatus: 200, hasExtM3U: true },
      durationMs,
    };
  }

  if (httpStatus !== 200) {
    return {
      id,
      label,
      status: CHECK_STATUS.FAIL,
      detail: `Manifest request failed (HTTP ${httpStatus})`,
      detailData: { httpStatus, hasExtM3U: false },
      durationMs,
    };
  }

  return {
    id,
    label,
    status: CHECK_STATUS.FAIL,
    detail: 'Invalid manifest response',
    detailData: { httpStatus: 200, hasExtM3U: false },
    durationMs,
  };
}
